import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState, useEffect } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const CheckoutContext = /*#__PURE__*/React.createContext({});
const LOCAL_STORAGE_KEY = 'int-checkout';
const saveToLocal = state => {
  window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(_objectSpread({
    timestamp: new Date().valueOf()
  }, state)));
};
const getFromLocal = () => {
  if (typeof window !== 'undefined') {
    return JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY));
  }
};

// TODO useReducer...
export const CheckoutProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: customerEmail,
    1: setCustomerEmail
  } = useState(null);
  const {
    0: shippingAddress,
    1: setShippingAddress
  } = useState(null);
  const {
    0: invoiceAddress,
    1: setInvoiceAddress
  } = useState(null);
  const {
    0: comment,
    1: setComment
  } = useState(null);
  const {
    0: paymentMethod,
    1: setPaymentMethod
  } = useState(null);
  const {
    0: availableShippingMethods,
    1: setAvailableShippingMethods
  } = useState(null);
  const {
    0: shippingMethod,
    1: setShippingMethod
  } = useState(null);
  const {
    0: shippingCost,
    1: setShippingCost
  } = useState(0);
  const {
    0: presentWrap,
    1: setPresentWrap
  } = useState(false);
  const {
    0: payPal,
    1: setPayPal
  } = useState(null);
  const {
    0: mounted,
    1: setMounted
  } = useState(false);
  const resetAll = () => {
    window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    setCustomerEmail(null);
    setShippingAddress(null);
    setInvoiceAddress(null);
    setComment(null);
    setPaymentMethod(null);
    setShippingMethod(null);
    setShippingCost(0);
    setPresentWrap(false);
  };
  useEffect(() => {
    if (!mounted) {
      setMounted(true);
      const localState = getFromLocal();
      if (localState) {
        setCustomerEmail(localState.customerEmail);
        setShippingAddress(localState.shippingAddress);
        setInvoiceAddress(localState.invoiceAddress);
        setComment(localState.comment);
        setPaymentMethod(localState.paymentMethod);
        setShippingMethod(localState.shippingMethod);
        setShippingCost(localState.shippingCost);
        setPresentWrap(localState.presentWrap);
      }
    } else {
      saveToLocal({
        customerEmail,
        shippingAddress,
        invoiceAddress,
        comment,
        paymentMethod,
        shippingMethod,
        shippingCost,
        presentWrap
      });
    }
    //eslint-disable-next-line
  }, [customerEmail, shippingAddress, invoiceAddress, comment, paymentMethod, shippingMethod, presentWrap, shippingCost]);
  return ___EmotionJSX(CheckoutContext.Provider, {
    value: {
      customerEmail,
      setCustomerEmail,
      shippingAddress,
      setShippingAddress,
      invoiceAddress,
      setInvoiceAddress,
      comment,
      setComment,
      paymentMethod,
      setPaymentMethod,
      availableShippingMethods,
      setAvailableShippingMethods,
      shippingMethod,
      setShippingMethod,
      shippingCost,
      setShippingCost,
      presentWrap,
      setPresentWrap,
      payPal,
      setPayPal,
      resetAll
    }
  }, children);
};